"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _brandFamilyBlack = _interopRequireDefault(require("../images/brand-family-black.svg"));

var _background = _interopRequireDefault(require("../images/raceroster-25/background.jpg"));

var _stitches = require("../stitches.config");

var images = {
  blackBrandFamily: _brandFamilyBlack.default
};
var theme = (0, _stitches.createTheme)('raceroster-25', {
  background: {
    image: "url(".concat(_background.default, ")")
  },
  buttonShape: {
    default: '$square'
  },
  colors: {
    inputBorder: '$grey600',
    inputBorderFocused: '$black',
    inputText: '$grey700',
    primary: '$smurfBlue',
    primaryHover: '$smurfBlueLight',
    primaryContrast: '$smurfBlueContrast',
    textPrimary: '$textBlack'
  },
  space: {
    logo: '10%'
  }
});
var _default = {
  images: images,
  theme: theme
};
exports.default = _default;